module.exports = __webpack_public_path__ + "img/dsci0127.d62c7caf.jpg";